import React from 'react';
import { Link } from 'react-router-dom';
import './NotFoundPage.css';

function NotFoundPage() {
  return (
    <div className="not-found-page">
      <div className="not-found-container">
        <h1 className="error-code">404</h1>
        <h2 className="error-title">PAGE NOT FOUND</h2>
        <p className="error-message">
          The page you're looking for doesn't exist or may have been moved.
        </p>
        
        <div className="navigation-suggestions">
          <h3>EXPLORE IDEA FARM</h3>
          <div className="suggestion-grid">
            <Link to="/" className="suggestion-card">
              <span className="suggestion-text">HOME</span>
            </Link>
            
            <Link to="/events" className="suggestion-card">
              <span className="suggestion-text">EVENTS</span>
            </Link>
            
            <Link to="/shop" className="suggestion-card">
              <span className="suggestion-text">SHOP</span>
            </Link>
            
            <Link to="/recording" className="suggestion-card">
              <span className="suggestion-text">RECORDING</span>
            </Link>
            
            <Link to="/labs" className="suggestion-card">
              <span className="suggestion-text">LABS</span>
            </Link>
            
            <Link to="/contact" className="suggestion-card">
              <span className="suggestion-text">CONTACT</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotFoundPage;
